import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var FileV2 = /*#__PURE__*/function (_Entity) {
  _inherits(FileV2, _Entity);

  var _super = _createSuper(FileV2);

  function FileV2() {
    _classCallCheck(this, FileV2);

    return _super.apply(this, arguments);
  }

  _createClass(FileV2, [{
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "statusName",
    get: function get() {
      return this.props.statusName;
    }
  }, {
    key: "fileKey",
    get: function get() {
      return this.props.fileKey;
    }
  }, {
    key: "url",
    get: function get() {
      return this.props.url;
    }
  }, {
    key: "uploadUrl",
    get: function get() {
      return this.props.uploadUrl;
    }
  }, {
    key: "expiresAt",
    get: function get() {
      return this.props.expiresAt;
    }
  }, {
    key: "fileName",
    get: function get() {
      return this.props.fileName;
    }
  }, {
    key: "mimeType",
    get: function get() {
      return this.props.mimeType;
    }
  }, {
    key: "size",
    get: function get() {
      return this.props.size;
    }
  }, {
    key: "resourceType",
    get: function get() {
      return this.props.resourceType;
    }
  }, {
    key: "usageType",
    get: function get() {
      return this.props.usageType;
    }
  }, {
    key: "linkedEntity",
    get: function get() {
      return this.props.linkedEntity;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this.props.metadata;
    }
  }, {
    key: "ownerId",
    get: function get() {
      return this.props.ownerId;
    }
  }, {
    key: "extension",
    get: function get() {
      return this.props.extension;
    }
  }, {
    key: "resourceTypeName",
    get: function get() {
      return this.props.resourceTypeName;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }, {
    key: "createdAtUnix",
    get: function get() {
      return this.props.createdAtUnix;
    }
  }, {
    key: "updatedAtUnix",
    get: function get() {
      return this.props.updatedAtUnix;
    }
  }, {
    key: "version",
    get: function get() {
      return this.props.version;
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var guardCollections = [{
        argument: props.status,
        argumentName: 'Status'
      }, {
        argument: props.fileKey,
        argumentName: 'File key'
      }, {
        argument: props.url,
        argumentName: 'Url'
      }];
      var result = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!result.succeeded) {
        var _result$message;

        return Result.fail((_result$message = result.message) !== null && _result$message !== void 0 ? _result$message : 'Invalid file storage v2');
      }

      return Result.ok(new FileV2(props, new UniqueEntityID(id)));
    }
  }]);

  return FileV2;
}(Entity);